<template>
	<div>
		<div class="flex flex-b flex-wrap">
			<div class="itembg bg flex flex-c">
				<div class="title">今日新增用户数</div>
				<div class="value">{{data.user||0}}</div>
			</div>
			<div class="itembg bg1 flex flex-c">
				<div class="title">今日新增营收（元）</div>
				<div class="value">{{data.price||0}}</div>
			</div>
			<div class="itembg bg2 flex flex-c">
				<div class="title">今日新增订单数</div>
				<div class="value">{{data.order||0}}</div>
			</div>
			<div class="itembg bg3 flex flex-c">
				<div class="title">今日新增付费会员数</div>
				<div class="value">{{data.member||0}}</div>
			</div>
		</div>
		<h3>业务功能</h3>
		<div class="flex flex-b flex-wrap">
			<el-card shadow="never" class="w-24 menuItem flex" v-for="item in tabs">
				<div class="flex center pointer" @click="toUrl(item.path)">
					<div class="menuName">{{item.name}}</div>
				</div>
			</el-card>
		</div>
		
		<h3>运营功能</h3>
		<div class="flex flex-b flex-wrap">
			<el-card shadow="never" class="w-24 menuItem flex" v-for="item in tabs1">
				<div class="flex center pointer" @click="toUrl(item.path)">
					<div class="menuName">{{item.name}}</div>
				</div>
			</el-card>
		</div>
		
		<h3>数据管理</h3>
		<div class="flex flex-b flex-wrap">
			<el-card shadow="never" class="w-24 menuItem flex" v-for="item in tabs2">
				<div class="flex center pointer" @click="toUrl(item.path)">
					<div class="menuName">{{item.name}}</div>
				</div>
			</el-card>
		</div>
	</div>
</template>

<script>
	import {
		getDesk
	} from "@/api/console"
	export default{
		data(){
			return{
				tabs:[
					{name:'新增课程',path:'/course-list-dialog',icon:''},
					{name:'课程推荐',path:'/course-rec-list',icon:''},
					{name:'课程下发',path:'/course-lssued-list',icon:''},
					{name:'新增培训',path:'/training-list-dialog',icon:''},
					{name:'培训推荐',path:'/training-rec',icon:''}
				],
				tabs1:[
					{name:'Banner管理',path:'/banner-list',icon:''},
					{name:'消息推送',path:'/message-list',icon:''},
					{name:'核心技术管理',path:'/core-technology',icon:''},
					{name:'服务据点管理',path:'/service-list',icon:''},
				],
				tabs2:[
					{name:'课程订单',path:'/course-order-list',icon:''},
					{name:'培训订单',path:'/training-order-list',icon:''},
					{name:'会员订单',path:'/member-order-list',icon:''},
					{name:'财务指标',path:'/finanic-statics',icon:''},
				],
				data:''
			}
		},
		mounted() {
			this.getDesk()
		},
		methods:{
			toUrl(url){
				this.$router.push({
					path:url
				})
			},
			async getDesk(){
				const {
					status,
					data
				} = await getDesk();
				if (status !== 200) return;
				this.data = data.result
			}
			
		}
	}
</script>

<style lang="less" scoped>
	h3{
		margin: 30px 0;
	}
	.itembg{
		width: 24%;
		border-radius: 10px;
		padding: 50px 0;
		.title{
			font-size: 14px;
			color: #fff;
		}
		.value{
			font-size: 22px;
			color: #fff;
			margin-top: 5px;
		}
	}
	.bg{
		background: #60df9c;
	}
	.bg1{
		background: #6696f4;
	}
	.bg2{
		background: #365668;
	}
	.bg3{
		background: #f58459;
	}
	.menuItem{
		margin-bottom: 20px;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		.menuName{
			font-size: 16px;
			margin-left: 20px;
		}
	}
</style>